<template>
  <iframe
    id="JotFormIFrame-203443089586160"
    ref="jotform"
    title="Customer Onboarding"
    onload="window.parent.scrollTo(0,0)"
    allowtransparency="true"
    allowfullscreen="true"
    src="https://form.jotform.com/203443089586160"
    frameborder="0"
    style="min-width: 100%; height: 580px; border: none"
    scrolling="no"
  >
  </iframe>
</template>

<script>
import JotFormMixin from '@/mixins/jotform'
export default {
  mixins: [JotFormMixin]
}
</script>
